import { Directive, EventEmitter, Input, Output } from "@angular/core";
import { LoyaltyMode } from "@shopping-angular-components/loyalty";
import { Currency } from "projects/common/model/landingModel";
import { OfferCardData } from "../offer-card-data.model";

@Directive()
export abstract class AbstractOfferCard {
  @Input() moduleId: string;
  @Input() moduleIndex: number;
  @Input() uniqueId?: string;
  @Input() positionIndex: number;

  @Input() data: OfferCardData;
  @Input() currency: Currency;
  @Input() locale: string;
  @Input() loyaltyMode: LoyaltyMode | null;
  @Input() flow: string;
  @Input() product: string;
  @Input() moduleReferer?: string;

  @Output() offerClicked = new EventEmitter<void>();
  
  constructor() {}

  onOfferClicked() {
    this.offerClicked.emit();
  }
}
